export default __webpack_public_path__ + "static/media/653.cec26c05.png";